module.exports = "/_next/static/images/b7ac611a744ad7d065dc48712a510ee1-logos-hero.svg";